export default {
  computed: {
    country_name: function() {
      const countryCode = this.location && this.location.address && this.location.address.country
      if (!countryCode) return ''

      const countryNames = {
        US: 'United States',
        CA: 'Canada',
        GB: 'United Kingdom',
        AU: 'Australia',
        JP: 'Japan',
        FR: 'France',
        DE: 'Germany',
        ES: 'Spain',
        IT: 'Italy',
        BR: 'Brazil',
        MX: 'Mexico',
        IN: 'India',
        CN: 'China',
        RU: 'Russia',
        KR: 'South Korea',
        NL: 'Netherlands',
        SE: 'Sweden',
        CH: 'Switzerland',
        NO: 'Norway',
        DK: 'Denmark',
        FI: 'Finland',
        BE: 'Belgium',
        AT: 'Austria',
        IE: 'Ireland',
        PL: 'Poland',
        PT: 'Portugal',
        CZ: 'Czech Republic',
        HU: 'Hungary',
        GR: 'Greece',
        TR: 'Turkey',
        IL: 'Israel',
        EG: 'Egypt',
        ZA: 'South Africa',
        NG: 'Nigeria',
        AR: 'Argentina',
        CL: 'Chile',
        CO: 'Colombia',
        PE: 'Peru',
        VE: 'Venezuela',
        TH: 'Thailand',
        MY: 'Malaysia',
        SG: 'Singapore',
        ID: 'Indonesia',
        PH: 'Philippines',
        VN: 'Vietnam',
        NZ: 'New Zealand'
      }
      return countryNames[countryCode] || countryCode
    }
  }
}
